<template>
	<v-row>
		<v-col>
			<v-form v-model="formIsValid" ref="faqsForm">
				<faq-editor
						:faqs="faqData"
						:formRef="$refs.faqsForm"
						formText="These FAQs are pass-specific and will appear on the 'More' tab of the mobile pass."
						formTitle="Pass Specific FAQs"
						@change="updateFaqs"
				></faq-editor>
			</v-form>
			<save-form
					v-if="!faqDragging"
					:refs="$refs"
					:is-saving="isSaving"
					newForms
					save-text="Save"
					@cancel-action="cancelChanges"
					@save-action="saveDestination"
			></save-form>
		</v-col>
	</v-row>
</template>

<script>
import customizationMixin from './Mixins/customizationMixin';
import FaqEditor from '@app/Shared/Components/FaqEditor.vue';

export default {
	name: 'PassCustomizationFaqs',
	mixins: [customizationMixin],
	components: {
		FaqEditor
	},

	data() {
		return {
			exitDialog: false,
			faqDragging: false,
			formIsValid: false,
			isDirty: false,
			isSaving: false,
			faqData: []
		};
	},
	created() {
		this.faqData = cloneDeep(this.pass.faqs);
	},
	mounted() {
		window.EventBus.$on('faq-drag-start', this.onDragStart);
		window.EventBus.$on('faq-drag-end', this.onDragEnd);
	},
	methods: {

		onDragEnd() {
			this.faqDragging = false;
		},
		onDragStart() {
			this.faqDragging = true;
		},

		updateFaqs(faqs) {
			this.isDirty = true;
			this.$set(this.localPass, 'faqs', faqs);
		}
	}
}
</script>

<style lang="scss" scoped>
.sortables > span > div {
	margin: 0 -1rem !important;
	padding: 1rem;
	border-top: solid 1px rgba(0, 0, 0, 0.096);

	&:hover {
		background-color: #f0f8f0 !important;
	}
}
</style>
